import { CommonUI } from "@src/common/CommonUI/CommonUI";
import { useResolvedPageLabels } from "@src/hooks/useResolvedPageLabels";
import { Fragment } from "react";
import { YourInfoForm } from "./YourInfoForm";

export const YourInfoStep = () => {
  const yourInfoStepLabels = useResolvedPageLabels("yourInfoStep");
  return (
    <Fragment>
      <CommonUI
        FormComponent={YourInfoForm}
        headingText={yourInfoStepLabels.headingText}
        metaTitle={yourInfoStepLabels.headingText}
        bodyText={
          <Fragment>
            Before your appointment, we’ll collect a few details to make sure your provider has the
            right information.
          </Fragment>
        }
      />
    </Fragment>
  );
};
